import { BellIcon } from "./Icons";
import type { BroadcastNotification } from "./broadcastNotify";

/** The floating "someone important said something" toast — auto-dismisses
 * after 10s (the countdown bar's animation duration mirrors the timer the
 * useBroadcastNotifications hook runs internally; they're kept in sync by
 * both being the same literal 10s, not by any shared state). Clicking it
 * marks the notification read immediately instead of waiting out the
 * timer. */
export default function BroadcastToast({
  notification,
  onOpen,
}: {
  notification: BroadcastNotification;
  onOpen: () => void;
}) {
  return (
    <div className="broadcast-toast" onClick={onOpen} role="button" tabIndex={0}>
      <span className="broadcast-toast__icon">
        <BellIcon size={16} />
      </span>
      <div className="broadcast-toast__body">
        <div className="broadcast-toast__label">Announcement</div>
        <div className="broadcast-toast__msg">{notification.message}</div>
      </div>
      <div className="broadcast-toast__bar" />
    </div>
  );
}
